import React from 'react';
import {Platform, View } from "react-native";
import styles from "../../../stylesheet";
import { createNativeStackNavigator } from "@react-navigation/native-stack";
import { createStackNavigator } from "@react-navigation/stack";
import ReportsScreen from "../screens/MidLevel/ReportsScreen/ReportsScreen";
import IndividualReportScreen from "../screens/MidLevel/ReportsScreen/IndividualReportScreen";
import ReportDashboardScreen from "../screens/MidLevel/ReportsScreen/ReportDashboardScreen";
import CustomDashboardsScreen from "../screens/MidLevel/ReportsScreen/CustomDashboardsScreen";
import DashboardEditorScreen from "../screens/MidLevel/ReportsScreen/DashboardEditorScreen";
import { ReportsStackParamList } from "../types";
import { themeSelector } from '@reduxLocal/selectors/themeSelector';

const ReportStack = Platform.select({default:  createNativeStackNavigator<ReportsStackParamList>(), web: createStackNavigator<ReportsStackParamList>() })

const ReportNavigator = ({ ...navigation }: any) => {
  const theme = themeSelector();
  return (
    <View style={{ flex: 1, flexDirection: 'row' }}>
      <ReportStack.Navigator
        screenOptions={{
          headerShown: false, cardStyle: {
            backgroundColor: theme ? "white" : "black",
          }
        }}
        initialRouteName={'ReportsList'}>
        <ReportStack.Screen
          name='ReportsList'
          component={ReportsScreen}
          />
        <ReportStack.Screen
          name="ReportDashboard"
          component={ReportDashboardScreen} />
        <ReportStack.Screen
          name='IndividualReport'
          component={IndividualReportScreen} />
        <ReportStack.Screen
          name='CustomDashboards'
          component={CustomDashboardsScreen} />
        <ReportStack.Screen
          name='DashboardEditor'
          component={DashboardEditorScreen} />
      </ReportStack.Navigator>
    </View>
  )
}

export { ReportStack, ReportNavigator }